import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth';
import {JOURNEY_CHILD_EVENTS} from '@/app/auth/events/JourneyChildEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewOnboardingKidFinancialLiteracy = useCallback(
    (parentId: string) => {
      trackEvent(JOURNEY_CHILD_EVENTS.VIEW_ONBOARDING_KID_FINANCIAL_LITERACY, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          id: parentId ?? '',
          role: RolesAccount.PARENT,
        },
      });
    },
    [trackEvent],
  );

  const trackSelectOnboardingKidFinancialLiteracy = useCallback(() => {
    trackEvent(
      JOURNEY_CHILD_EVENTS.SELECT_ONBOARDING_KID_FINANCIAL_LITERACY_CONTINUE,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
    );
  }, [trackEvent]);

  return {
    trackViewOnboardingKidFinancialLiteracy,
    trackSelectOnboardingKidFinancialLiteracy,
  };
};
